/**
 * <s-sticky-buy watch="element-id"> — mobile sticky buy bar.
 * Stays hidden (and inert) until the watched main buy area has scrolled up out of view,
 * so it never covers the product title or the real Add to Cart button.
 * Sets data-visible on itself while shown; CSS owns the slide.
 */
class SStickyBuy extends HTMLElement {
  #io;

  connectedCallback() {
    const target = document.getElementById(this.getAttribute('watch') || '');
    if (!target) return;

    this.#io = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.#io.observe(target);
  }

  disconnectedCallback() {
    this.#io?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
